import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported

const styles = {
    label: "block text-md md:text-lg text-gray-700 font-proximanova",
    sublabel: "block text-sm md:text-md text-gray-700 font-proximanova",
};

const PrimaryDetails = ({
    newProduct,
    setNewProduct,
    selectedCategories,
    availCategories,
    handleCategoryToggle,
    shouldValidatePrimary,
    setShouldValidatePrimary,
}) => {
    const [errors, setErrors] = useState({
        productName: false,
        email: false,
        productFeatures: false,
        categories: false,
    });

    const [validated, setValidated] = useState({
        productName: false,
        email: false,
        productFeatures: false,
        categories: false,
    });

    // Validate Product Name
    const validateProductName = (name) => {
        if (!name) {
            setErrors((prevErrors) => ({ ...prevErrors, productName: true }));
            setValidated((prevValidated) => ({ ...prevValidated, productName: false }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, productName: false }));
            setValidated((prevValidated) => ({ ...prevValidated, productName: true }));
        }
    };

    // Validate Email
    const validateEmail = (email) => {
        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            setErrors((prevErrors) => ({ ...prevErrors, email: true }));
            setValidated((prevValidated) => ({ ...prevValidated, email: false }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, email: false }));
            setValidated((prevValidated) => ({ ...prevValidated, email: true }));
        }
    };

    // Validate Product Description
    const validateProductDescription = (description) => {
        if (!description) {
            setErrors((prevErrors) => ({ ...prevErrors, productDescription: true }));
            setValidated((prevValidated) => ({ ...prevValidated, productDescription: false }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, productDescription: false }));
            setValidated((prevValidated) => ({ ...prevValidated, productDescription: true }));
        }
    };

    // Validate Product Features
    const validateProductFeatures = (features) => {
        if (!features) {
            setErrors((prevErrors) => ({ ...prevErrors, productFeatures: true }));
            setValidated((prevValidated) => ({ ...prevValidated, productFeatures: false }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, productFeatures: false }));
            setValidated((prevValidated) => ({ ...prevValidated, productFeatures: true }));
        }
    };

    // Validate Categories
    const validateCategories = () => {
        if (selectedCategories.length === 0) {
            setErrors((prevErrors) => ({ ...prevErrors, categories: true }));
            setValidated((prevValidated) => ({ ...prevValidated, categories: false }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, categories: false }));
            setValidated((prevValidated) => ({ ...prevValidated, categories: true }));
        }
    };

    const validateFields = () => {
        validateProductName(newProduct.productName);
        validateEmail(newProduct.email);
        validateProductFeatures(newProduct.productFeatures);
        validateCategories();
        return validated.productName && validated.email && validated.productFeatures && validated.categories;
    };

    useEffect(() => {
        if (shouldValidatePrimary) {
            const valid = validateFields(); // Validate fields 
            setShouldValidatePrimary(false); //Reset shouldValidate
        }
    }, [shouldValidatePrimary, setShouldValidatePrimary]);

    return (
        <div className="w-full flex flex-col">

            <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Product Name
                <span style={{ color: '#9a016a' }}> *</span> </label>
            <input
                type="text"
                placeholder="Please enter your product name"
                className={`${errors.productName ? 'is-invalid' : validated.productName ? 'is-valid' : ''} w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none`}
                value={newProduct.productName}
                onChange={(e) => {
                    setNewProduct({ ...newProduct, productName: e.target.value });
                    validateProductName(e.target.value); // Validate as user types
                }}
            />
            {errors.productName && (
                <div className="font-proximanova text-[15px] text-[#fd5764] mt-1 mb-0">Product name is required.</div>
            )}


            {/* Email for Inquiries */}
            <div className="mt-[8px]">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Email for Inquiries
                    <span style={{ color: '#9a016a' }}> *</span> </label>
                <input
                    type="email"
                    className={`${errors.email ? 'is-invalid' : validated.email ? 'is-valid' : ''} w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none`}
                    placeholder="Please enter an email address to which inquiries should be redirected"
                    value={newProduct.email}
                    onChange={(e) => {
                        setNewProduct({ ...newProduct, email: e.target.value });
                        validateEmail(e.target.value); // Validate as user types
                    }}
                />
                {errors.email && (
                    <div className="font-proximanova text-[15px] text-[#fd5764] mt-1 mb-0">Please enter a valid email address.</div>
                )}
            </div>

            {/* Product Website */}
            <div className="mt-[8px]">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Website
                    <span style={{ color: '#9a016a' }}> *</span> </label>
                <input
                    className={`${errors.websiteUrl ? 'is-invalid' : validated.websiteUrl ? 'is-valid' : ''} w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none`}
                    placeholder="Please enter the URL of your product, if any"
                    value={newProduct.websiteUrl}
                    onChange={(e) => {
                        setNewProduct({ ...newProduct, websiteUrl: e.target.value });
                        // validateWebsite(e.target.value); // Validate as user types
                    }}
                />
                {errors.websiteUrl && (
                    <div className="font-proximanova text-[15px] text-[#fd5764] mt-1 mb-0">Please enter a valid url.</div>
                )}
            </div>

            {/* Product Description */}
            <div className="mt-[8px]">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Description
                    <span style={{ color: '#9a016a' }}> *</span>
                </label>
                <textarea
                    className={`${errors.productDescription ? 'is-invalid' : validated.websiproductDescriptionteUrl ? 'is-valid' : ''} w-full h-[120px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none`}
                    placeholder="Please enter your product description (2000 characters max)"
                    value={newProduct.productDescription}
                    onChange={(e) => {
                        setNewProduct({ ...newProduct, productDescription: e.target.value });
                        validateProductDescription(e.target.value); // Validate as user types
                    }}
                />
                {errors.productDescription && (
                    <div className="font-proximanova text-[15px] text-[#fd5764] mt-1 mb-0">Product description is required.</div>
                )}
            </div>

            {/* Product Features */}
            <div className="mt-[8px]">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Features
                    <span style={{ color: '#9a016a' }}> *</span>
                </label>
                <textarea
                    className={`${errors.productFeatures ? 'is-invalid' : validated.productFeatures ? 'is-valid' : ''} w-full h-[120px] rounded-none p-2 font-proximanova text-[18px] bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none`}
                    placeholder="Please list the features of your product (2000 characters max)"
                    value={newProduct.productFeatures}
                    onChange={(e) => {
                        setNewProduct({ ...newProduct, productFeatures: e.target.value });
                        validateProductFeatures(e.target.value); // Validate as user types
                    }}
                />
                {errors.productFeatures && (
                    <div className="font-proximanova text-[15px] text-[#fd5764] mt-1 mb-0">Product features are required.</div>
                )}
            </div>

            {/* Categories */}
            <div className="mt-[8px]">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1" style={{ lineHeight: '1.35' }}>Categories
                    <span style={{ color: '#9a016a' }}>*</span>
                </label>
                <label className="font-proximanova font-[400] text-[16px] text-[#404040]" style={{ lineHeight: '1.35' }}>
                    Please select the category (or categories) that your product falls under
                </label>
                <div className="flex flex-wrap gap-2 mt-2">
                    {availCategories.map((category, index) => (
                        <button
                            key={index}
                            type="button"
                            className={`btn ${selectedCategories.includes(category.number)
                                ? 'btn-primary'
                                : 'btn-outline-primary'} transition-colors duration-200 text-[18px] text-proximanova`}
                            onClick={() => {
                                handleCategoryToggle(category);
                                // validateCategories(); // Validate categories on click
                            }}
                        >
                            {category.label}
                        </button>
                    ))}
                </div>
                {errors.categories &&
                    <div className="font-proximanova text-[15px] text-[#fd5764] mt-1 mb-0">At least one category must be selected.</div>
                }
            </div>

        </div>
    );
};

export default PrimaryDetails;
